export default {"src":"/_next/static/media/watch.606be62b.svg","height":12,"width":16};